import { RunIcon } from '../../utils/icons';

import React from 'react';

const ManDownIcon = (props) => (
	<RunIcon {...props} style={{transform: 'rotate(-65deg)'}} />
);

export default ManDownIcon;